import { GameListRep } from "@/api/home";
import { server } from "@/utils/client";
import { Local } from "@/utils/storage";

// 前台用户绑定手机号
export const getBindPhoneApi = () => {
    return server.post<any>({
        url: "/v1/api/user/bind_phone",
        toast: true,
    });
};

// 前台用户手机号是否存在
export const getCheckUserPhoneExistApi = (params: any) => {
    return server.get<any>({
        url: "/v1/api/user/check_user_phone_exist",
        params,
        toast: true,
    });
};

// 找回密码
export const getFindPwdApi = (data: any) => {
    return server.post<any>({
        url: "/v1/api/user/find_pwd",
        data,
        toast: true,
    });
};

// 前台用户谷歌登录
export const getGoogleLoginApi = () => {
    return server.post<any>({
        url: "/v1/api/user/google_login",
    });
};

// 前台用户登录
export const getLoginApi = (data: any) => {
    return server.post<any>({
        url: "/v1/api/user/login",
        data,
        toast: true,
    });
};

// 前台用户登出
export const getLogoutApi = () => {
    return server.post<any>({
        url: "/v1/api/user/logout",
        toast: true,
    });
};

// 前台用户注册
export const getRegisterApi = (data: any) => {
    return server.post<any>({
        url: "/v1/api/user/register",
        data,
        toast: true,
    });
};

// 前台用户注册发送验证码
export const getSendCodeApi = (params: any) => {
    return server.get<any>({
        url: "/v1/api/user/send_code",
        params,
        toast: true,
    });
};

/**
 * @description 验证验证码
 */
export const checkCodeApi = (data: { mobile: string; code: string }) => {
    return server.post({
        url: "/v1/api/user/check_code",
        data,
    });
};
export interface UserInfoRep {
    /**
     * 账号
     */
    account?: string;
    /**
     * 用户头像
     */
    avatar_url?: string;
    /**
     * 邮箱地址
     */
    email?: string;
    /**
     * ID
     */
    id?: number;
    /**
     * 用户标签
     */
    label?: string;
    /**
     * 真实姓名
     */
    nick_name?: string;
    /**
     * 推荐码
     */
    referrer_code?: string;
    /**
     * 上级名字
     */
    referrer_name?: string;
    /**
     * 用户地址
     */
    user_address?: string;
    /**
     * 用户名
     */
    user_name?: string;
    /**
     * 用户电话号码
     */
    user_phone?: string;
    // 正在进行中的游戏
    play_list?: GameListRep[];

    avatar?: number;
}
// 前台用户获取信息
export const getUserInfoApi = () => {
    return server.post<UserInfoRep>({
        url: "/v1/api/user/user_info",
    });
};

export interface Wallet {
    is_open_no_bonus?: 0 | 1;
    /**
     * 用户头像
     */
    avatar_url: string;
    /**
     * 货币类型
     */
    currency: string;
    /**
     * 当前免费钱包打码量
     */
    current_free_score_rollover: number;
    /**
     * 当前输钱钱包打码量
     */
    current_lose_score_rollover: number;
    /**
     * 当前奖金打码量
     */
    current_point_rollover: number;
    /**
     * 当前现金打码量
     */
    current_score_rollover: number;
    /**
     * 累计充值金额
     */
    deposit: number;
    /**
     * 第一次充值时间
     */
    first_pay_time: number;
    /**
     * 免费币
     */
    free_score: number;
    /**
     * 锁定活动代币
     */
    lock_point: number;
    /**
     * 锁定积分
     */
    lock_score: number;
    /**
     * 重玩币
     */
    lose_score: number;
    /**
     * 真实姓名
     */
    nick_name: string;
    /**
     * 活动代币
     */
    point: number;
    /**
     * 积分
     */
    score: number | undefined;
    /**
     * 目标免费钱包打码量
     */
    target_free_score_rollover: number;
    /**
     * 目标输钱钱包打码量
     */
    target_lose_score_rollover: number;
    /**
     * 目标奖金打码量
     */
    target_point_rollover: number;
    /**
     * 目标现金打码量
     */
    target_score_rollover: number;
    /**
     * 累计免费钱包打码量
     */
    total_free_score_rollover: number;
    /**
     * 累计输钱钱包打码量
     */
    total_lose_score_rollover: number;
    /**
     * 累计奖金打码量
     */
    total_point_rollover: number;
    /**
     * 历史领取红包总次数
     */
    total_receive_red_packet: number;
    /**
     * 历史红包总金额
     */
    total_red_packet: number;
    /**
     * 累计现金打码量
     */
    total_score_rollover: number;
    /**
     * 用户名
     */
    user_name: string;

    notice: {
        lose_score: number;
    };
    /**
     * 是否允许转移彩金
     */
    is_point_transfer?: boolean;
    /**
     * 是否允许转移免费币
     */
    is_free_transfer?: boolean;
    /**
     * 是否允许转移重玩币
     */
    is_lose_transfer?: boolean;

    tips_reset_rollover?: boolean;
    /**
     * 免费币转移本金比例
     */
    free_transfer_ratio?: number;
    /**
     * 免费币转移最小金额
     */
    free_transfer_min?: number;
    /**
     * 重玩币转移本金比例
     */
    lose_transfer_ratio?: number;
    /**
     * 重玩币转移最小金额
     */
    lose_transfer_min?: number;
    /**
     * 免费币最大提现金额
     */
    free_transfer_max?: number;
    /**
     * 重玩币最小提现金额
     */
    lose_transfer_max?: number;

    no_bonus_config?: number;

    withdraw: {
        enable: boolean;
        balance: number;
        able_amount: number;
        clear_balance: number;
        current_rollover: number;
        target_rollover: number;
        tips_pop: boolean;
        clear_item_ids: number[];
    };
}
// 前台用户获取金额信息
export const getUserMoneyApi = () => {
    return server.post<Wallet>({
        url: "/v1/api/user/user_money",
    });
};
export interface UserRechargeResult {
    pay_url: string;
    pay_qr_code: string;
    icon: string;
    trade_no: string;
    amount: number;
}
// 前台用户充值
export const getUserRechargeApi = (data: any) => {
    return server.post<UserRechargeResult>({
        url: "/v1/api/user/user_recharge",
        data: { ...data, click_id: Local.getKey("ban_click_id") ?? undefined },
        toast: true,
    });
};
// 前台用户VIP信息
// POST /v1/api/user/user_vip_info
// 接口ID：201160713
// 接口地址：https://app.apifox.com/link/project/4790544/apis/api-201160713
export interface UserVipInfo {
    /**
     * vip经验
     */
    vip_exp: number;
    /**
     * vip等级
     */
    vip_level: number;
    /**
     * 下一级vip等级
     */
    vip_next_level: any;
    /**
     * vip等级经验
     */
    vip_score_exp: number;

    /**
     * vip 最高返水
     */
    vip_cashback: number;
}
export const getUserVipApi = () => {
    return server.post<UserVipInfo>({
        url: "/v1/api/user/user_vip_info",
    });
};

export interface DepositsRep {
    id: string;
    /**
     * 充值金额
     */
    amount: number;
    /**
     * 充值状态：created、pending、finished、canceled
     */
    status: string;
    /**
     * 充值时间：时间戳秒
     */
    time: number;
    /**
     * 充值标题说明
     */
    title: string;
    /**
     * 类型
     */
    type: number;
    /**
     * 活动类型
     */
    sub_type: number;
}

// 用户钱包余额转移
export const getUserTransferApi = (data: { wallet_type: number }) => {
    return server.post<any>({
        url: "/v1/api/user/user_transfer",
        data,
    });
};

/**
 * 获取用户最新充值订单信息
 *   POST /v1/api/user/user_deposit_latest
 *   接口ID：265942160
 *   接口地址：https://app.apifox.com/link/project/4790544/apis/api-265942160
 */
export interface DepositsLatestRep {
    /**
     * 是否首充： 1是 2否
     */
    is_first_pay: number;
    /**
     * 是否成功: 1是 2否
     */
    is_success: number;
    /**
     * 订单编号
     */
    order_id: string;
    /**
     * 订单状态
     */
    status: number;
}
export const getUserDepositApi = () => {
    return server.post<DepositsLatestRep>({
        url: "/v1/api/user/user_deposit_latest",
    });
};

export const toggleUserBounsApi = (is_open: 1 | 0) => {
    return server.post<any>({
        url: "/v1/api/user/bonus/openNoBonus",
        data: {
            is_open,
        },
    });
};

export const cleanBounsApi = (is_clear: 0 | 1) => {
    return server.post<any>({
        url: "/v1/api/user/bonus/clearBonus",
        data: {
            is_clear,
        },
    });
};

export const changeUserInfo = (data: { nick_name: string; avatar: number }) => {
    ///v1/api/user/player/setUserInfo
    return server.post<any>({
        url: "/v1/api/user/player/setUserInfo",
        data,
    });
};

export interface RewordItem {
    coin_type: number;
    amount: number;
    rollover: number;
    ratio: number;
}
export interface LevelInfoItem {
    id: number;
    bet: number;
    pay: number;
    type: number;
    status: number;
    reward: RewordItem[];
    daily_reward_num: number;
    daily_reward_multiple_num: number;
    weekly_reward_num: number;
    weekly_reward_multiple_num: number;
    weekly_reward_start_time: number;
    weekly_reward_end_time: number;
    monthly_reward_num: number;
    monthly_reward_multiple_num: number;
    monthly_reward_start_time: number;
    monthly_reward_end_time: number;
    first_bankruptcy_reward_num: number;
    second_bankruptcy_reward_num: number;
    spin: number;
}
export interface RewardInfoItem {
    type: 1 | 2 | 3 | 4 | 5 | 6;
    status: number;
    is_double: boolean;
    is_double_notify: boolean;
    reward: RewordItem[];
    cur_pay: number;
    double_pay: number;
    cur_bet: number;
    target_bet: number;
    start_time: number;
    end_time: number;
    multiple: number;
}

export interface NewVip {
    vip_level: number;
    vip_exp: number;
    vip_pay_exp: number;
    sub_daily_bet: number;
    keep_vip_level_rule: number;
    max_down: number;
    level_info: LevelInfoItem[];
    reward_info: RewardInfoItem[];
    keep_level_condition: {
        cur_bet: number;
        cur_pay: number;
        bet: number;
        pay: number;
        end_time: number;
    };
    config: {
        is_level_up_reward: boolean;
        is_daily_reward: boolean;
        is_daily_double_reward: boolean;
        is_weekly_reward: boolean;
        is_weekly_double_reward: boolean;
        is_monthly_reward: boolean;
        is_monthly_double_reward: boolean;
        is_first_bankruptcy: boolean;
        is_second_bankruptcy: boolean;
    };
}

export const getNewVip = () => {
    return server.post<NewVip>({
        url: "/v1/api/user/new_vip/getNewVipInfo",
    });
};

export const claimVip = (data: { type: 1 | 2 | 3 | 4 | 5 | 6; level?: number }) => {
    return server.post({
        url: "/v1/api/user/new_vip/claimNewVipReward",
        data,
    });
};
